export default "__VITE_ASSET__fc135a18__"